import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import SidebarAdmin from './SidebarAdmin'
import SidebarTecnico from './SidebarTecnico'
import { Context } from '../context/UserContext'
// import Footer from './Footer'
import SidebarWarehouse from './SidebarWarehouse';
import SidebarVivo from './SidebarVivo';

export default function LayoutReports() {

    const { user } = useContext(Context)
    
    return (
        <div className='flex flex-row'>
            <div className='flex-none min-h-screen w-fit'>
                { user.role === 'tecnico'
                    ? <SidebarTecnico />
                    : user.role === 'warehouse'
                    ? <SidebarWarehouse />
                    : user.role === 'vivogestao'
                    ? <SidebarVivo />
                    : <SidebarAdmin />
                }
            </div>
            <div className='w-full flex flex-col items-center'>
                <div className='w-full h-full flex justify-start items-start'>{<Outlet context={{ user }}/>}</div>
                {/* <div className='w-full h-fit flex justify-center items-center mb-8'>
                    <Footer />
                </div> */}
            </div>
            
        </div>
    )
}
